export default {
  carriers: [],
  priceTableHelpers: {},
  priceTable: {}
}



// WEBPACK FOOTER //
// ./src/components/pricetable/store/state.js